import { Component, OnInit, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';
import { NotificationTemplateModel } from '../../../../../../store/notification-template/model';
import { Observable } from 'rxjs';
import { NotificationTemplateFacade } from '../../../../../../store/notification-template/facade';

@Component({
  selector: 'app-notification-templates',
  templateUrl: './notification-templates.component.html',
  styleUrls: ['./notification-templates.component.scss'],
  host: {
    class: 'p-4',
  },
  standalone: false,
})
export class NotificationTemplatesComponent implements OnInit {
  private titleService = inject(Title);
  translate = inject(TranslateService);
  private notificationTemplateFacade = inject(NotificationTemplateFacade);

  notificationTemplates$: Observable<NotificationTemplateModel[]>;

  ngOnInit(): void {
    // Page title
    this.translate.get('TITLE_MAIN').subscribe(value => {
      this.titleService.setTitle(value);
    });

    this.notificationTemplates$ = this.notificationTemplateFacade.allTemplates$;
  }

  public rowClick($event) {
    if ($event.isExpanded) {
      $event.component.collapseRow($event.data.id);
    } else {
      $event.component.expandRow($event.data.id);
    }
  }

  public onSave(notificationTemplate: NotificationTemplateModel) {
    this.notificationTemplateFacade.saveTemplate(notificationTemplate);
  }
}
